export var CreationMethod;
(function (CreationMethod) {
    CreationMethod["default"] = "default";
    CreationMethod["force"] = "force";
})(CreationMethod || (CreationMethod = {}));
export const defaultCreationMethod = CreationMethod.default;
export const defaultPriority = 1;
